// <div data-controller="components--horizontal-slider">
//
// </div>
import {Controller} from "@hotwired/stimulus";
import Splide from "@splidejs/splide";

export default class extends Controller {
  static targets = [ "slider", "track" ];
  static classes = [ "" ]
  static values = {
    height: Number,
    autoplayInterval: { type: Number, default: 0 }
  };

  initialize() {
    this.slider = null;
  }

  get slidersCount() {
    return this.trackTarget.querySelectorAll(".splide__slide").length
  }

  connect() {
    // Use requestAnimationFrame to ensure smooth initialization after render
    requestAnimationFrame(() => {
      this.initializeSlider();
    });
  }
  
  initializeSlider() {
    const options = {
      perPage: 1,
      gap: "1rem",
      rewind : true,
      pagination: false,
      padding: 0,
      fixedHeight: this.heightValue,
      arrows: this.slidersCount > 1,
    };

    if (this.autoplayIntervalValue > 0) {
      options.autoplay = true;
      options.interval = this.autoplayIntervalValue;
      options.pauseOnHover = true;
    }

    this.slider = new Splide(this.sliderTarget, options);

    this.slider.mount();
    this.sliderTarget.classList.remove("hidden");
  }

  disconnect() {
    if (this.slider) {
      this.slider.destroy();
    }
  }
}